import { EmbeddedVideo } from "@/libraries/design/components";

export interface UniformEmbeddedVideoProps {
    url: string;
    title?: string;
    thumbnailSrc?: string;
    thumbnailAlt?: string;
}

const UniformEmbeddedVideo = ({
    url,
    title,
    thumbnailSrc,
    thumbnailAlt = ""
}: UniformEmbeddedVideoProps) => {
    return (
        <EmbeddedVideo
            embedUrl={url}
            title={title}
            thumbnail={{
                src: thumbnailSrc ? thumbnailSrc : "",
                alt: thumbnailAlt
            }}
        />
    );
};

export default UniformEmbeddedVideo;
